module.exports = __webpack_public_path__ + "static/img/speaker-notes.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/speaker-notes.svg
// module id = 416
// module chunks = 0